import anime from "animejs";

const load = () => {

  const step = {
    first: 'M0,0 L1920,0 C1877.36538,22.4546995 1822.94959,47.2822934 1756.75265,74.4827819 C1657.45723,115.283515 1399.6496,129.752602 1252.88405,129.752602 C1010.83839,129.752602 656.665215,220.629279 543.613399,256.083618 C466.222967,280.35414 285.018501,333.992934 0,417 L0,0 Z',
    second: 'M0,0 L1920,0 C1814.25694,5.22370692 1728.28694,21.4358046 1662.09,48.636293 C1562.79458,89.4370257 1237.41698,191.938283 1090.65143,191.938283 C848.605772,191.938283 683.025399,302.81103 569.973583,338.265369 C492.583152,362.535891 302.591957,388.780768 0,417 L0,0 Z'
  }
  anime({
    targets: '#top_header_liquid',
    d: [{
        value: [step.first, step.second]
      },
      {
        value: step.first
      }
    ],
    duration: 12000,
    autoplay: true,
    easing: 'linear',
    loop: true,
  })


  anime({
    targets: '#top_header_liquid_2',
    d: [{
        value: [step.first, step.second]
      },
      {
        value: step.first
      }
    ],
    duration: 12000,
    autoplay: true,
    easing: 'linear',
    loop: true,
  })
}

export default load